import { Identifier } from 'src/nicheaim-infrastructure/application/adapters/out/repositories/fhir/resources';
import { createWrapper } from '../../fhir-react/base';

export const HealthcareServiceWrapper = createWrapper('HealthcareService', (healthCareService) => ({
  getMINT: (): Identifier | undefined =>
    healthCareService?.identifier?.find?.(
      ({ system }) => system === process.env.REACT_APP_MINT_PROGRAM_IDENTIFIER
    ),
}));
export type WrappedHealthcareService = ReturnType<typeof HealthcareServiceWrapper>;
